module.exports = __webpack_public_path__ + "img/icn_brand19_black.7cb2d96f.svg";